var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('edit-case',{ref:"caseInfoEditRef"}),(_vm.isEditMode && _vm.canViewActionSideBar)?_c('the-sidebar'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }